import {
  // 单数据源筛选器
  SINGLE_SOURCE_SELECT as SINGLE_SOURCE_SELECT_FILTER,
  // 级联国家筛选器
  REGION as REGION_SELECT_FILTER,
  // 品类筛选器
  GENRETOR as GENRE_SELECT_FILTER,
  // 日期筛选器
  RANGE_TIME as RANGE_TIME_SELECT_FILTER,
  // Product Model筛选器
  SENSOR_TOWER_TAG_PRODUCT_MODEL,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';
import type { IRegionType } from '@/pages/intelligence/types/common';
import type { IMobileStoreRankTopGlobalCompareFetchParams } from '@/pages/intelligence/types/storeRank';
import { isSameDate, handleGenreFilterParams } from '@intelligence/utils/filterUtils';

const getSelectedMarkets = (regionFilterExtend: any, defaultRegions?: string[]) => {
  const extendMarkets = regionFilterExtend?.markets;
  if (Array.isArray(extendMarkets) && extendMarkets.length > 0) {
    return extendMarkets;
  }

  const filterMarkets = regionFilterExtend?.filterMarkets;
  if (Array.isArray(filterMarkets) && filterMarkets.length > 0) {
    return filterMarkets;
  }

  if (Array.isArray(defaultRegions) && defaultRegions.length > 0) {
    return defaultRegions;
  }

  return [];
};

const getRegionTypeByMarkets = (markets: string[]): IRegionType => {
  if (markets?.length === 1 && ['global', 'global_wo_china'].includes(markets?.[0])) {
    return 'region';
  }

  return 'market';
};

export const getInitialFetchParams = (
  filterExtend: any,
  defaultFetchParams: IMobileStoreRankTopGlobalCompareFetchParams,
) => {
  const newFetchParams: any = {};
  /** 各个筛选器的继承值 **/
  const singleSourceExtend = filterExtend?.[SINGLE_SOURCE_SELECT_FILTER];
  const regionFilterExtend = filterExtend?.[REGION_SELECT_FILTER];
  const genreFilterExtend = filterExtend?.[GENRE_SELECT_FILTER];
  const timeExtend = filterExtend?.[RANGE_TIME_SELECT_FILTER];
  /** 各个筛选器的继承值 **/

  if (timeExtend && timeExtend?.filterType === 'date') {
    const isSameDay = isSameDate(timeExtend?.start_date, timeExtend?.end_date, 'day');
    if (isSameDay) {
      newFetchParams.date = timeExtend?.end_date || '';
    }
  }
  if (singleSourceExtend) {
    newFetchParams.source = singleSourceExtend?.value ?? defaultFetchParams?.source;
  }
  if (regionFilterExtend) {
    // feat:参数除了global/wochina, 其他都是market
    const selectedMarkets = getSelectedMarkets(regionFilterExtend, defaultFetchParams?.regions);
    newFetchParams.region_type = getRegionTypeByMarkets(selectedMarkets);
    newFetchParams.regions = selectedMarkets;
  }
  if (genreFilterExtend) {
    Object.assign(newFetchParams, handleGenreFilterParams(genreFilterExtend));
  }

  // 处理 Product Model 继承
  const productModelFilterExtend = filterExtend?.[SENSOR_TOWER_TAG_PRODUCT_MODEL];
  if (productModelFilterExtend?.value?.length > 0) {
    newFetchParams[SENSOR_TOWER_TAG_PRODUCT_MODEL] = productModelFilterExtend;
  }

  return {
    ...defaultFetchParams,
    ...newFetchParams
  };
};
